import {SummonDataProperty} from 'src/tracker/model/property/summon/summon-data-property'

export const ramuhProperty = new SummonDataProperty(
  "1e271c85-35ea-4391-a6b3-e1e55e16e2ff",
  "Ramuh",
)
